import { Basket, BasketItem, IBasket, IBasketProductItem } from "@/entities";
import { IBasketRepository } from ".";
import {
    CreateBasketMutation,
    GetBasketQuery,
    UpdateBasketMutation,
} from "@/API";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";
import getEndpoint from "@/utils/domain";
import axios from "axios";
import { createHeader } from "@/utils/createHeader";

// export const ENDPOINT_PATH = getEndpoint("/api/basket");
export const ENDPOINT_PATH = "https://ad3pw0tze2.execute-api.ap-southeast-1.amazonaws.com/Prod";
export class BasketAPIRepository implements IBasketRepository {
    async getBasket(basketID: string, apikey: string): Promise<Basket> {
        // const res = await API.graphql(graphqlOperation(queries.getBasket, {
        //     id: basketID,
        // })) as any

        // const b = (res.data as GetBasketQuery).getBasket;
        // b?.basketID
        // console.log(res);

        // if (res.status == 200) {
        //     const b = (res.data as GetBasketQuery).getBasket
        //     const basket: any = b
        //     console.log(basket);
        //     // return new Basket(basket)
        // } else {
        //     console.log("body", res.body);
        //     // if (res.body.contains("basket doesnt exist")) {
        //     //     throw new Error("basket doesnt exist");
        //     // }
        //     throw new Error("Failed to get basket");
        // }
        // const body = JSON.stringify({ basketId: basketID })

        const response = await axios.post(
            ENDPOINT_PATH + "/get",
            {
                basketId: basketID,
            },
            {
                headers: createHeader({ apikey, idToken: null }) as any,
                validateStatus: function (status) {
                    return true;
                },
            }
        );

        if (response.status == 200) {
            const b = response?.data as IBasket;
            return new Basket(b);
        } else {
            // console.warn(response.data.error);
            if (response.data?.error?.includes("basket doesnt exist")) {
                throw new Error("basket doesnt exist");
            }
            throw new Error("Failed to get basket");
        }
    }

    async createBasket(basketID: string, saleID: string): Promise<Basket> {
        // const response = await API.graphql(graphqlOperation(mutations.createBasket, {
        //     basketID,
        //     saleID
        // })) as any
        // if (response.status == 200) {
        //     const b = (response.data as CreateBasketMutation).createBasket
        //     const basket: any = b
        //     return new Basket(basket)
        // } else {
        //     throw new Error("Failed to create basket");
        // }
        const response = (await axios.post(ENDPOINT_PATH + "/create", {
            basketId: basketID,
            ownerId: saleID,
            branchId: "any",
            basketName: basketID,
        })) as any;
        if (response.status == 200) {
            const b = response?.data.result as IBasket;
            return new Basket(b);
        } else {
            throw new Error("Failed to create basket");
        }
    }

    async removeBasket(basketID: string): Promise<boolean> {
        // const response = await API.graphql(graphqlOperation(mutations.deleteBasket, {
        //     basketID,
        //     saleID
        // })) as any
        // if (response.status == 200) {
        //     return true
        // } else {
        //     throw new Error("Failed to remove basket");
        // }
        const body = JSON.stringify({
            basketId: basketID,
        });
        const response = (await axios.post(ENDPOINT_PATH + "/remove", {
            body: body,
        })) as any;
        if (response.status == 200) {
            return true;
        } else {
            throw new Error("Failed to remove basket");
        }
    }

    async emptyBasket(basketID: string): Promise<Basket> {
        // const response = await API.graphql(graphqlOperation(mutations.updateBasket, {
        //     basketID,
        //     saleID
        // })) as any
        // if (response.status == 200) {
        //     const b = (response.data as UpdateBasketMutation).updateBasket
        //     const basket: any = b
        //     return new Basket(basket)
        // } else {
        //     throw new Error("Failed to empty basket");
        // }
        const response = (await axios.post(
            ENDPOINT_PATH + "/empty",
            {
                basketId: basketID,
            },
            {
                validateStatus: function (status) {
                    return true;
                },
            }
        )) as any;
        if (response.status == 200) {
            const b = response?.data as IBasket;
            return new Basket(b);
        } else {
            throw new Error("Failed to empty basket");
        }
    }
    async addBasket(basketID: string, item: BasketItem): Promise<Basket> {
        const response = (await axios.post(
            ENDPOINT_PATH + "/add",
            {
                basketId: basketID,
                items: [
                    {
                        sku: item.sku,
                        quantity: item.quantity,
                    },
                ],
            },
            {
                validateStatus: function (status) {
                    return true;
                },
            }
        )) as any;
        if (response.status == 200) {
            const b = response?.data as IBasket;
            return new Basket(b);
        } else {
            throw new Error("Failed to add basket");
        }
    }
}
